/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import AuthService from "services/auth.service";

import routes from "routes.js";

var ps;

class Dashboard extends React.Component {
  state = {
    backgroundColor: "green",
  };
  mainPanel = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainPanel.current.scrollTop = 0;
    }
  }
  handleColorClick = (color) => {
    this.setState({ backgroundColor: color });
  };6

  



  render() {


    let MainRoutes = routes[0].map((prop, key) => {
      return (
        <Route  path={prop.layout + prop.path} component= {prop.component}   key={key}/> );
         
      }); 
        


      let ReportingRoutes = routes[1].map((prop, key) => {
        return (
          <Route  path={prop.layout + prop.path} component= {prop.component}   key={key}/> );
           
        }); 
        
     
 

    const currentUser =  AuthService.getCurrentUser();

    return (
      <div>

{(currentUser) ?

      <div className="wrapper">

        <Sidebar
          {...this.props}
          routes={routes[0]}
          reportingroutes={routes[1]}

          backgroundColor={this.state.backgroundColor}
        />
        <div className="main-panel" ref={this.mainPanel}>
          <DemoNavbar {...this.props} />
          <Switch>
          {MainRoutes}

          {ReportingRoutes}


            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <Footer fluid />
        </div>



      </div>:<Redirect from="/*" to="/login" />
}
      </div>
    );
  }
}

export default Dashboard;
